module.exports = __webpack_public_path__ + "images/index/img01.b90a506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/sshl/img01.jpg
// module id = UCLU
// module chunks = 21